import { Injectable } from '@angular/core';
import { DiseaseVaccineModel } from '../../../models/master-data/diseases-vaccines.model';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { BaseService } from '../../../shared/services/base.service';
@Injectable()
export class DiseasesVaccinesService {
    constructor(public baseService : BaseService) {

    }

    getDiseaseList() {
        const url = MasterDataUrl.GET_ALL_DISEASE;
        return this.baseService.getData(url);
    }

    getVaccinesList(param) {
        const url = MasterDataUrl.GET_DISEASE_VACCINE;
        return this.baseService.getData(url, param);
    }

    getAllVaccine() {
        const url = MasterDataUrl.GET_ALL_VACCINE_FOR_ADD_DISEASE;
        return this.baseService.getData(url);
    }

    removeVaccine(id){
        let url = MasterDataUrl.REMOVE_DISEASE_VACCINE.replace('{id}', id);
        return this.baseService.delete(url);
    }

    updateVaccine(id){
        let url = MasterDataUrl.UPDATE_DEFAULT_VACCINE.replace('{id}', id);
        return this.baseService.put(url, id);
    }

    addDiseaseVaccine(param){
        const url = MasterDataUrl.ADD_NEW_DISEASE_VACCINE;
        return this.baseService.post(url, param);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/diseases-vaccines/diseases-vaccines.service.ts